<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import noteIcon from "../../../../static/assets/images/note-1.svg";
import noteIconActive from "../../../../static/assets/images/note-2.svg";
import flagIcon1 from "../../../../static/assets/images/flag-1.svg";
import flagIcon2 from "../../../../static/assets/images/flag-2.svg";
import flagIcon3 from "../../../../static/assets/images/flag-3.svg";
import moment from "moment";
export default {
  name: "UserList",
  data() {
    return {
      sorting: "",
      activities: [],
      flagIcon1,
      noteIcon,
      noteIconActive,
      flagsListIcons: [flagIcon1, flagIcon2, flagIcon3],
      limit: 25,
      currentPageNumber: 1,
      searchStr: null,
      searchResult: true,
      rows: 3,
      pagedBy: 5,
      fields: [
        {
          key: "flag_intensity",
          sortable: true,
          class: "icon-table-header flag-table",
        },
        {
          key: "flag_internal_notes",
          sortable: true,
          class: "icon-table-header note-table",
        },
        {
          key: "type",
          sortable: true,
        },
        {
          key: "working_title",
          label: "Working Title",
          sortable: true,
        },
        {
          key: "series",
          sortable: true,
        },
        {
          key: "levels",
          sortable: true,
        },
        {
          key: "emotion",
          sortable: true,
        },
        {
          key: "intensity",
          label: "INT",
          sortable: true,
        },
        {
          key: "modified",
          label: "Last Edited",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentPaginationPage: "commons/currentPaginationPage",
      currentDataList: "commons/currentDataList",
      fieldOptionsChunked: "commons/fieldOptionsChunked",
      coloursOptions: "commons/coloursOptions",
    }),
  },
  mounted() {
    this.$store.dispatch(`commons/getFieldOptions`);
    var args = {
      limit: 25,
      type: "todo",
      status: "draft",
      offset: 1,
    };

    if (this.searchStr) {
      args["search"] = this.searchStr;
    }
    if (this.sorting) {
      args["sorting"] = this.sorting;
    }

    this.fetchData(args, 1);
  },
  methods: {
    dateStatus(date) {
      return moment(date).fromNow();
    },
    getFlag: function (id) {
      if (id) {
        return `/static/assets/images/flag-${id}.svg`;
      }
      return `/static/assets/images/flag-1.svg`;
    },
    open(activity) {
      this.$store.commit(`commons/setActivity`, activity);
      this.$store.commit("commons/setOpenedNotes", true);
    },
    updateFlag(activity) {
      var activityType = activity.type;
      if (activity.type == "stretch_flow") {
        activityType = "stretchflow";
      }
      const flag =
        activity.flag_intensity == 3 ? 1 : activity.flag_intensity + 1;
      this.$store.commit(`${activityType}s/setUpdateActivity`, {
        activity: activity,
        type: "flag_intensity",
        flag: flag,
      });
      this.$store.dispatch(`${activityType}s/updateFlag`, activity.id);
    },
    optionValue(id, type) {
      const data =
        this.fieldOptionsChunked[type] && id
          ? this.fieldOptionsChunked[type].find((option) => option.id == id)
          : null;

      if (data) return data.label;
    },
    convertType(type) {
      return type == "stretch_flow" ? "stretch-flow" : type;
    },
    countPage() {
      if (this.activities.count)
        return Math.ceil(this.activities.count / this.limit);
    },
    fetchData(args, page) {
      this.searchResult = true;
      this.$store.commit("commons/setPreloader", true);
      this.$store.dispatch("commons/listByType", args).then(
        (res) => {
          this.activities = res;
          this.$store.commit("commons/setPreloader", false);
        },
        (error) => {
          this.$store.commit("commons/setPreloader", false);
          console.log(error);
        }
      );
      this.$store.commit("commons/setCurrentPaginationPage", page);
    },
    sortingFunc(ctx) {
      this.activities.results = [];
      this.sorting = ctx.sortDesc ? "-" : "";
      var sortby =
        ctx.sortBy == "working_title" ||
        ctx.sortBy == "type" ||
        ctx.sortBy == "created"
          ? ctx.sortBy
          : ctx.sortBy + "__label";

      this.sorting = this.sorting + sortby;

      var args = {
        limit: this.limit,
        type: "todo",
        status: "draft",
        offset: this.currentPageNumber,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    page(number) {
      this.currentPageNumber = number;
      var args = {
        limit: this.limit,
        type: "todo",
        status: "draft",
        offset: this.currentPageNumber,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    next() {
      this.currentPageNumber = this.currentPageNumber + 1;
      var args = {
        limit: this.limit,
        type: "todo",
        status: "draft",
        offset: this.currentPageNumber,
      };
      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    prev() {
      this.currentPageNumber = this.currentPageNumber - 1;
      var args = {
        limit: this.limit,
        type: "todo",
        status: "draft",
        offset: this.currentPageNumber,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    changelimit() {
      var args = {
        limit: this.limit,
        type: "todo",
        status: "draft",
        offset: this.currentPageNumber,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    search() {
      var args = {
        limit: this.limit,
        type: "todo",
        status: "draft",
        offset: 1,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, 1);
    },
    clearSearch() {
      if (!this.searchStr) {
        this.search();
      }
    },
    clearSearchClick() {
      this.searchStr = "";
      this.search();
    },
    updateStatus(activity) {
      this.$store.commit("commons/setPreloader", true);
      this.$store.commit(`commons/setActivity`, activity);
      this.$store.commit(`commons/setActivityStatus`, "ready-to-film");
      this.$store.dispatch(`commons/updateActivity`, activity.id).then(
        (res) => {
          this.$store.commit(`commons/setSavingForm`, "Saved");

          var args = {
            limit: this.limit,
            type: "todo",
            status: "draft",
            offset: this.currentPageNumber,
          };

          if (this.searchStr) {
            args["search"] = this.searchStr;
          }
          if (this.sorting) {
            args["sorting"] = this.sorting;
          }

          this.fetchData(args, this.currentPageNumber);
          
        },
        (error) => {
          console.log(error);
        }
      );
    },
    scriptBuilder(activity) {
      this.$store.commit("scripts/setOpened", true);
      this.$store.commit(`commons/setActivity`, activity);
    },

    openActivity(activity, index) {
      this.$router.push(
        `/update-${this.convertType(activity.type)}/${activity.id}`
      );
    },
    activeColour(id) {
      return this.coloursOptions && id
        ? this.coloursOptions.find((option) => option.id == id)
        : null;
    },
    checkFlag(flag) {
      if (flag == 0) {
        return 1;
      }
      return flag;
    },
  },
};
</script>
<style lang="scss">
.user {
  tbody {
    td {
      &:last-child {
        width: 480px;
        text-align: right;

        .status {
          width: 170px;
          display: inline-block;
          text-align: right;
        }
      }
    }
  }
}
table {
  thead {
    th {
      &.icon-table-header {
        width: 20px;
        & > div {
          font-size: 0;
          width: 22px;
          height: 22px;
          background-position: center !important;
          background-size: cover !important;
          margin-right: 10px !important;
          cursor: pointer;
        }
        &.flag-table {
          & > div {
            background-image: var(--flagIcon1);
          }
        }
        &.note-table {
          & > div {
            background-image: var(--noteIcon);
          }
        }
      }
    }
  }
  tbody {
    td {
      &.icon-table-header {
        text-align: center;
      }
    }
  }
}
</style>
<template>
  <div
    class="data-list user"
    :style="{
      '--flagIcon1': 'url(' + flagIcon1 + ')',
      '--noteIcon': 'url(' + noteIcon + ')',
    }"
  >
    <div class="filter d-flex align-items-center">
      <b-input-group>
        <b-form-input
          v-model="searchStr"
          type="text"
          placeholder="Search workouts by name, status, …"
          v-on:keyup.enter="search"
        ></b-form-input>
        <b-input-group-append>
          <b-input-group-text class="mr-2">
            <b-icon icon="search" v-if="!searchStr" />
            <b-icon
              icon="x-circle-fill"
              class="text-danger cursor-pointer"
              @click="clearSearchClick()"
              v-if="searchStr"
            />
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>
      <b-input-group-append>
        <b-button
          text="Button"
          variant="primary bg-white text-primary"
          @click="search()"
          >FILTER</b-button
        >
      </b-input-group-append>
    </div>
    <b-table
      @sort-changed="sortingFunc"
      :sticky-header="true"
      responsive
      :fields="fields"
      :items="activities.results"
      v-if="searchResult"
    >
      <template #cell(flag_intensity)="data">
        <div class="icons">
          <span
            class="px-2 flag"
            :style="{
              backgroundImage:
                'url(\'' +
                flagsListIcons[checkFlag(data.item.flag_intensity) - 1] +
                '\')',
            }"
            @click="updateFlag(data.item)"
          ></span>
        </div>
      </template>
      <template #cell(flag_internal_notes)="data">
        <div class="icons tooltip-wrapper">
          <span
            v-if="!data.item.flag_internal_notes"
            class="px-2 notes"
            :style="{
              backgroundImage: 'url(\'' + noteIcon + '\')',
            }"
            @click="open(data.item)"
          ></span>
          <span
            v-if="data.item.flag_internal_notes"
            class="px-2 has-note"
            :style="{
              backgroundImage: 'url(\'' + noteIconActive + '\')',
            }"
            @click="open(data.item)"
          >
          </span>

          <div class="data" v-if="data.item.flag_internal_notes">
            {{ data.item.flag_internal_notes }}
          </div>
        </div>
      </template>

      <template #cell(working_title)="data">
        <b
          ><a
            v-bind:href="`#/update-${convertType(data.item.type)}/${
              data.item.id
            }`"
            >{{ data.item.working_title }}</a
          ></b
        >
      </template>

      <template #cell(type)="data">
        <span
          class="badge inline-block type text-black"
          :style="{
            background: activeColour(data.item.colour)
              ? activeColour(data.item.colour).value
              : '',
          }"
          >{{ data.item.type }}
        </span>
      </template>

      <template #cell(series)="data"
        ><span>{{ optionValue(data.item.series, "SRS") }}</span></template
      >
      <template #cell(levels)="data">
        <div class="level-wrapper">
          <span v-for="level in data.item.levels" :key="level.id">
            {{ level }}
          </span>
        </div>
      </template>
      <template #cell(emotion)="data">
        <span v-if="data.item.type == 'stretch_flow'">{{
          optionValue(data.item.emotion, "STRETCHFLOW_EMO")
        }}</span>
        <span v-if="data.item.type != 'stretch_flow'">{{
          optionValue(data.item.emotion, "EMO")
        }}</span>
      </template>

      <template #cell(intensity)="data">
        <span v-if="data.item.type == 'stretch_flow'">{{
          optionValue(data.item.intensity, "STRETCHFLOW_HS")
        }}</span>
        <span v-if="data.item.type != 'stretch_flow'">{{
          optionValue(data.item.intensity, "HS")
        }}</span>
      </template>

      <template #cell(modified)="data">
        <span class="timestamp">{{ dateStatus(data.item.modified) }}</span>

        <span
          class="text-primary status cursor-pointer"
          @click="updateStatus(data.item)"
          v-if="
            (data.item.filming_complete && data.item.with_equipment != null) ||
            (data.item.has_script && data.item.with_equipment != null)
          "
          ><b>MARK AS READY TO FILM </b>
        </span>
        <span
          class="text-danger status"
          v-if="
            (!data.item.has_script && !data.item.filming_complete) ||
            data.item.with_equipment == null
          "
          ><b>ADD INFORMATION </b>
          <b-icon
            icon="exclamation-triangle-fill"
            scale=".9"
            variant="danger"
          ></b-icon>
        </span>

        <b class="text-primary px-4"
          ><a
            v-bind:href="`#/update-${convertType(data.item.type)}/${
              data.item.id
            }`"
            >OPEN</a
          ></b
        >

        <b-dropdown id="dropdown-right" right class="action-button">
          <template #button-content>
            <b-icon icon="three-dots" scale="2" class="cursor-pointer"></b-icon>
          </template>
          <b-dropdown-item @click="scriptBuilder(data.item)"
            >Edit script</b-dropdown-item
          >
        </b-dropdown>
      </template>
    </b-table>

    <h2 v-if="!searchResult" class="text-center py-5">
      No "{{ searchStr }} " found
    </h2>

    <div
      class="
        pagination-wrapper
        d-flex
        justify-content-between
        align-items-center
        w-100
      "
      v-if="searchResult"
    >
      <div class="total">{{ activities.count }} results</div>
      <div class="pagination">
        <ul
          role="menubar"
          aria-disabled="false"
          aria-label="Pagination"
          class="pagination b-pagination"
          v-if="countPage() != 1"
        >
          <li
            role="presentation"
            aria-hidden="true"
            class="page-item cursor-pointer"
            v-if="activities.previous"
          >
            <span
              aria-label="Go to previous page"
              class="page-link text-primary"
              @click="prev()"
            >
              <b-icon icon="chevron-left" aria-hidden="true"></b-icon
            ></span>
          </li>
          <li
            class="page-item"
            v-for="item in countPage()"
            :key="item"
            :class="item == currentPaginationPage ? 'active' : ''"
          >
            <button class="page-link" @click="page(item)">{{ item }}</button>
          </li>
          <li
            role="presentation"
            aria-hidden="true"
            class="page-item cursor-pointer"
            v-if="activities.next"
          >
            <span
              aria-label="Go to next page"
              class="page-link text-primary"
              @click="next()"
            >
              <b-icon icon="chevron-right" aria-hidden="true"></b-icon
            ></span>
          </li>
        </ul>
      </div>
      <div
        class="
          dropdown-pagination
          d-flex
          justify-content-end
          align-items-center
        "
      >
        <b-form-group class="select">
          <b-form-select v-model="limit" @change="changelimit()">
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-form-select>
        </b-form-group>
        Per page
      </div>
    </div>
  </div>
</template>